export default __webpack_public_path__ + "static/Plots0025-b6bad736eb8dde240a2df2b0567c396a.jpg";